const DigitalSignatureDocumentStatus = Object.freeze({
  Draft: 1,
  SignatureSetupProcess: 2,
  SignaturePending: 3,
  Cancelled: 4,
  Signed: 5,
  RenderedIneffective: 6,
  Rejected: 7,

  // Backward-compatible aliases used by existing screens.
  DocNotGenerated: 1,
  InRow: 2,
  InSigningProcess: 3,
  Canceled: 4,
});

export const DigitalSignatureDocumentStatusColor = Object.freeze({
  [DigitalSignatureDocumentStatus.DocNotGenerated]: 'gray-16',
  [DigitalSignatureDocumentStatus.InRow]: 'gray-16',
  [DigitalSignatureDocumentStatus.InSigningProcess]: 'light-purple',
  [DigitalSignatureDocumentStatus.Canceled]: 'dark-red',
  [DigitalSignatureDocumentStatus.Signed]: 'light-green',
  [DigitalSignatureDocumentStatus.Rejected]: 'dark-red',
});

export default DigitalSignatureDocumentStatus;
